<div class="main-content">
  <div class="container-fluid">
    <div class="meeting-step-header">
      <h4>Second Meeting</h4>
      <p class="meeting-step-subtitle">
        Schedule the next call, share the contact e-mail template, then mark the meeting as completed.
      </p>
    </div>

    <router-outlet *ngIf="!loading" name="meeting_2"></router-outlet>
  </div>
</div>
